export const CHECKOUT_LABELS = 'checkout';
export const ACCOUNT_LABELS = 'account';
export const GLOBAL_LABELS = 'global';

// checkout billing
export const lblExpired = 'lbl_expired';

// checkout bagPage
export const lblCouponlistExpiring = 'lbl_couponlist_expiring';
export const lblCouponGenericOnholdMsg = 'lbl_coupon_generic_onhold_msg';
export const lblCouponFreeGiftWrappingOnHold = 'lbl_coupon_free_gift_wrapping_on_hold';
export const lblCouponThresholdOnholdMsg = 'lbl_coupon_threshold_onhold_msg';
export const lblCouponValidThru = 'lbl_coupon_validThru';
export const lblCouponAppleOnholdError = 'lbl_coupon_apple_onhold_error';

export const lblCouponPlaceCashError = 'lbl_coupon_placeCash_error';
export const lblCouponlistUseBy = 'lbl_couponlist_useBy';
export const lblCouponlistSavings = 'lbl_couponlist_savings';
export const lblCouponlistRewards = 'lbl_couponlist_rewards';
export const lblCouponlistPlaceCash = 'lbl_couponlist_placeCash';
export const lblCouponOnholdError = 'lbl_coupon_onhold_error';

// account accountOverview
export const lblBonusPointsBlackOutDayWarning = 'lbl_bonus_points_black_out_day_warning';
export const lblBonusPointsError = 'lbl_bonus_points_error';

// global placeRewards
export const lblMyRewardsApplied = 'lbl_my_rewards_applied';

// global accountDrawer
export const lblCouponCardNow = 'lbl_couponCard_now';
export const lblCouponOfferText = 'lbl_coupon_offerText';
export const lblOverviewCouponTypeReward = 'lbl_overview_couponTypeReward';

const CouponCardLabels = {
  checkout: {
    bagPage: {
      [lblCouponlistExpiring]: 'EXPIRING SOON!',
      [lblCouponGenericOnholdMsg]: 'Discount will be applied after Terms and Conditions are met.',
      [lblCouponFreeGiftWrappingOnHold]:
        'Discount will be applied when a standard gift service is selected',
      [lblCouponThresholdOnholdMsg]:
        'Your item total is $XX away from being able to redeem this reward',
      [lblCouponValidThru]: 'Valid thru',
      [lblCouponAppleOnholdError]: 'Please pay with Apple Pay to apply this coupon.',

      [lblCouponPlaceCashError]: 'Sorry, we are unable to apply your PLACE BUCKS.',
      [lblCouponlistUseBy]: 'Use by',
      [lblCouponlistSavings]: 'SAVINGS',
      [lblCouponlistRewards]: 'REWARDS',
      [lblCouponlistPlaceCash]: 'PLACE BUCKS',
      [lblCouponOnholdError]:
        'This coupon will apply to your purchase when you use your My Place Rewards Credit Card.',
      [lblCouponOfferText]: 'OFFER',
    },
    billing: {
      [lblExpired]: 'Expired',
    },
  },
  account: {
    accountOverview: {
      [lblBonusPointsBlackOutDayWarning]: 'Bonus points unavailable on',
      [lblBonusPointsError]: 'You have reached the max limit to apply Bonus Points Day Coupon',
      [lblOverviewCouponTypeReward]: 'REWARD',
    },
  },
  global: {
    accountDrawer: {
      [lblCouponCardNow]: 'Now',
    },
    placeRewards: {
      [lblMyRewardsApplied]: 'APPLIED!',
    },
  },
};
export default CouponCardLabels;
